<template>
  <div class="market-card">
    <div class="market-header">
      <h3>{{ name }}</h3>
      <div class="market-status">
        <div class="signal-dot" :class="signal"></div>
        <span class="status">{{ getStatusText(signal) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import axios from 'axios'

type SignalType = 'red' | 'yellow' | 'green' | 'loading'

interface SignalResponse {
  market: string
  timeframe: string
  signal: SignalType
  timestamp: string
  metadata: {
    volatility: number | null
    trend: string | null
  }
}

const props = defineProps<{
  marketId: string
  name: string
}>()

const signal = ref<SignalType>('loading')

const getStatusText = (signal: string) => {
  const statusMap: { [key: string]: string } = {
    'red': '高波动',
    'yellow': '中等波动',
    'green': '低波动',
    'loading': '计算中'
  }
  return statusMap[signal] || '未知状态'
}

const fetchSignal = async () => {
  try {
    const response = await axios.get<SignalResponse>(`/api/signal?market=${props.marketId}`)
    signal.value = response.data.signal
  } catch (error) {
    console.error(`获取${props.marketId}市场信号失败:`, error)
  }
}

let timer: number

onMounted(() => {
  fetchSignal()
  timer = window.setInterval(fetchSignal, 60000)
})

onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
  }
})
</script>

<style scoped>
.market-card {
  background: #111827;
  border-radius: 0.5rem;
  padding: 1.5rem;
  border: 1px solid #374151;
}

.market-header {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.market-header h3 {
  font-size: 1.25rem;
  font-weight: bold;
}

.market-status {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.signal-dot {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
}

.signal-dot.red { background: #ef4444; }
.signal-dot.yellow { background: #eab308; }
.signal-dot.green { background: #22c55e; }
.signal-dot.loading { background: #565656; }

.status {
  font-size: 1.125rem;
  color: #9ca3af;
}
</style>
